// TODO: Add an API exception class somewhere in this service. Use it to handle errors.
(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.api.core'

  require('angular')
    .module(MODULE_NAME, [
      require('angular-resource')
    ])
    .provider('ThismomentApi', apiProvider)

  function apiProvider () {
    return {
      $get: apiConfig
    }
  }

  apiConfig.$inject = ['SdkConfig', '$resource']
  function apiConfig (SdkConfig, $resource) {
    var ThismomentApi = {
      configureResource: configureResource,
      transformResponse: transformResponse
    }

    return ThismomentApi

    function configureResource (url, params, actions, options) {
      if (!params) {
        params = {
          account_id: SdkConfig.get('account_id'),
          group_id: SdkConfig.get('group_id')
        }
      }
      if (!actions) {
        actions = {
          save: { // TODO: Deprecate 'save' in favor of 'post'
            method: 'POST',
            transformResponse: transformResponse,
            isArray: false,
            headers: {
              'CCMT-Account-Id': SdkConfig.get('account_id')
            }
          },
          delete: {
            // $resource.get([parameters], [success], [error])
            method: 'DELETE',
            transformResponse: transformResponse,
            isArray: false,
            headers: {
              'CCMT-Account-Id': SdkConfig.get('account_id')
            }
          },
          get: {
            // $resource.get([parameters], [success], [error])
            method: 'GET',
            transformResponse: transformResponse,
            isArray: false,
            headers: {
              'CCMT-Account-Id': SdkConfig.get('account_id')
            }
          },
          query: { // TODO: Deprecate 'query' in favor of 'get'
            method: 'GET',
            transformResponse: transformResponse,
            isArray: false,
            headers: {
              'CCMT-Account-Id': SdkConfig.get('account_id')
            }
          },
          update: { // TODO: Deprecate 'update' in favor of 'patch'
            method: 'PATCH',
            transformResponse: transformResponse,
            isArray: false,
            headers: {
              'CCMT-Account-Id': SdkConfig.get('account_id')
            }
          },
          patch: {
            // $resource.patch([parameters], postData, [success], [error])
            method: 'PATCH',
            transformResponse: transformResponse,
            isArray: false,
            headers: {
              'CCMT-Account-Id': SdkConfig.get('account_id')
            }
          },
          post: {
            // $resource.post([parameters], postData, [success], [error])
            method: 'POST',
            transformResponse: transformResponse,
            isArray: false,
            headers: {
              'CCMT-Account-Id': SdkConfig.get('account_id')
            }
          }
        }
      }

      return $resource(url, params, actions, options)
    }

    function transformResponse (data, headers, status) {
      return {
        data: JSON.parse(data),
        headers: headers(),
        status: status
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/api/api.js